import handleCursors from './cursors.js'
import handleNav from './nav.js'
import handlePageTitle from './page-title.js'
import handleProjectTeaserFull from './project-teaser-full.js'
import handleLogoGrid from './logo-grid.js'
import handleFooter from './footer.js'
import TypeIt from 'typeit'

const navAnimationDuration = 300;

handleNav(navAnimationDuration);
handleCursors();
handlePageTitle();
handleProjectTeaserFull();
handleLogoGrid();

const animatedPhrasesTarget = document.querySelector('.animated-phrases__target');

if (animatedPhrasesTarget) {
    new TypeIt(animatedPhrasesTarget, {
        startDelay: 0,
        breakLines: false,
        loop: true,
        beforeString: async () => {
            handleFooter();
        },
        afterString: async () => {
            handleFooter();
        },
    }).go();
}